import React, { Fragment, useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import Avatar from "../images/avatar.png"
import { clearErrors, loadUserAction } from '../../redux/actions/userActions'
import { toast } from 'react-toastify'
import UpdateAvatar from "./UpateAvatar"
import Loader from '../loader/loader'
import { UPDATE_AVATAR_RESET } from '../../redux/constants/userConstant'
import { formatWhatsAppNumber } from "../../utils/whatsappLinkFormater"


const Profile = () => {





    const dispatch = useDispatch()

    const { user } = useSelector((state) => state.verifyEmailStore);

    const { loading, error: avatarError, message: avatarMessage } = useSelector((state) => state.updateavtar)

    const [showSection, setShowSection] = useState(false)




    useEffect(() => {
        const Headerlinkks = document.querySelectorAll(".headerLinks")
        const element = document.getElementById("profile")

        Headerlinkks.forEach(element => {
            element.classList.remove('activeHeaderLink')
        });

        element.classList.add('activeHeaderLink')

        document.title = `${user?.name} - Profile`;

    }, [user?.name])




    const hideSection = useCallback(() => {
        setShowSection(false)
    }, [])




    useEffect(() => {

        if (avatarMessage) {
            toast.success(avatarMessage)
            dispatch({ type: UPDATE_AVATAR_RESET })   // clear first to prevent running twice
            dispatch(loadUserAction())
            hideSection()
        }

        if (avatarError) {
            toast.error(avatarError)
            dispatch(clearErrors())
        }

    }, [dispatch, avatarMessage, avatarError, hideSection])


    const handleClassName = (orderStatus) => {


        if (orderStatus === "ACTIVE") return "text-green-600 bg-green-200";
        if (orderStatus === "BLOCKED") return "text-red-600 bg-red-200";
        if (orderStatus === "TEMPORARILY_BLOCKED") return "text-orange-600 bg-orange-200";

    }





    return (
        <Fragment>
            {loading && <Loader />}

            {/* Breadcrumb Header */}
            <section className='p-[1.5vmax]'>
                <div className="flex justify-between items-center bg-white p-[1vmax_2vmax] rounded-xl shadow-sm border border-gray-100">
                    <div className="flex items-center gap-3">
                        <div className="w-[0.4vmax] h-[1.8vmax] bg-indigo-600 rounded-full"></div>
                        <h2 className='text-[1.4vmax] lg:text-[1.1vmax] font-bold text-gray-800 uppercase tracking-wider'>My Profile</h2>
                    </div>
                    <div className="flex items-center gap-3 text-[0.9vmax] font-medium">
                        <Link to={'/'} className="text-gray-500 hover:text-indigo-600 transition-colors">Dashboard</Link>
                        <i className="fa-solid fa-chevron-right text-gray-300 text-[0.7vmax]"></i>
                        <span className='text-indigo-600'>Profile Settings</span>
                    </div>
                </div>
            </section>

            {/* Profile Hero Section */}
            <section className='p-[0vmax_1.5vmax]'>
                <div className="profile-bg min-h-[22vmax] p-[4vmax] flex flex-col items-center justify-center rounded-2xl relative overflow-hidden shadow-lg border border-white/20">
                    {/* Glassmorphism Overlay */}
                    <div className="absolute inset-0 bg-indigo-900/40 backdrop-blur-[2px]"></div>
                    
                    <div className="relative z-10 flex flex-col items-center">
                        <h1 className='text-center font-bold text-[4vmax] lg:text-[3vmax] text-white drop-shadow-lg mb-2 capitalize'>
                            {user?.name}
                        </h1>
                        <div className="px-[1.5vmax] py-[0.5vmax] bg-white/20 backdrop-blur-md rounded-full border border-white/30">
                            <span className='text-white font-bold text-[1.2vmax] lg:text-[0.9vmax] uppercase tracking-[0.2em]'>
                                {user?.role === "SUPER_ADMIN" ? "Super Admin" : user?.role === "ADMIN" ? "Admin" : user?.role === "PMM" ? 'Seller' : "PM"}
                            </span>
                        </div>
                    </div>
                </div>
            </section>

            {/* Profile Content Details */}
            <section className='p-[0vmax_3vmax] relative z-20 mt-[-4vmax] flex flex-col lg:flex-row gap-[2vmax]'>
                
                {/* Left Card: Basic Info & Avatar */}
                <div className="w-full lg:w-[35%] bg-white shadow-xl p-[2.5vmax] rounded-2xl border border-gray-100 flex flex-col items-center text-center">
                    <div className="relative mb-[2vmax]">
                        <div className="w-[10vmax] h-[10vmax] rounded-2xl overflow-hidden shadow-2 border-[0.4vmax] border-white">
                            <img src={user?.avatar_url || Avatar} alt="Profile" className='w-full h-full object-cover' />
                        </div>
                        <button 
                            className='absolute -bottom-3 -right-3 w-[3.5vmax] h-[3.5vmax] bg-indigo-600 text-white rounded-xl shadow-lg hover:bg-indigo-700 transition-all flex-center active:scale-90 border-[0.3vmax] border-white' 
                            onClick={() => setShowSection(true)}
                            title="Update Photo"
                        >
                            <i className="fa-solid fa-camera text-[1.2vmax]"></i>
                        </button>
                    </div>

                    <h3 className='text-[1.8vmax] lg:text-[1.4vmax] font-bold text-gray-800 capitalize mb-1'>{user?.name}</h3>
                    <p className="text-gray-500 font-medium mb-4">{user?.email}</p>
                    
                    <div className={`px-[1.2vmax] py-[0.4vmax] rounded-lg text-[0.8vmax] font-bold uppercase tracking-wider mb-6 ${handleClassName(user?.status)}`}>
                        {user?.status?.replaceAll("_", " ")}
                    </div>

                    <div className="w-full border-t border-gray-50 pt-[2vmax] mt-auto">
                        <p className="text-gray-400 text-[0.8vmax] mb-4">Member Since: {user?.created_at ? new Date(user.created_at).toLocaleDateString() : 'N/A'}</p>
                        {(user?.can_edit === 1 || user?.role === "SUPER_ADMIN" || user?.role === "ADMIN") && (
                            <Link 
                                to={'/add-user-details/'} 
                                className="w-full flex items-center justify-center gap-3 bg-gray-50 hover:bg-indigo-50 text-gray-600 hover:text-indigo-600 py-[0.8vmax] rounded-xl font-bold transition-all border border-gray-100 hover:border-indigo-100"
                            >
                                <i className="fa-solid fa-user-gear"></i>
                                Edit Detailed Profile
                            </Link>
                        )}
                    </div>
                </div>

                {/* Right Card: Contact & Bank Details */}
                <div className="w-full lg:w-[65%] bg-white shadow-xl rounded-2xl border border-gray-100 overflow-hidden flex flex-col">
                    
                    {/* Contact Info Tabs-like Header */}
                    <div className="bg-gray-50/50 p-[1.5vmax_2.5vmax] border-b border-gray-100 flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <i className="fa-solid fa-id-card text-indigo-600 text-[1.2vmax]"></i>
                            <h3 className="font-bold text-gray-800 text-[1.2vmax]">Contact & Account Information</h3>
                        </div>
                    </div>

                    <div className="p-[2.5vmax] flex flex-col gap-[2vmax]">
                        
                        {/* Grid for Contact Items */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-[1.5vmax]">
                            
                            <div className="flex items-start gap-4 p-4 rounded-xl bg-gray-50 border border-gray-100">
                                <div className="w-10 h-10 rounded-lg bg-white shadow-sm flex-center text-blue-500">
                                    <i className="fa-regular fa-envelope text-lg"></i>
                                </div>
                                <div>
                                    <p className="text-xs font-bold text-gray-400 uppercase tracking-tight">Email Address</p>
                                    <p className="text-sm font-semibold text-gray-700">{user?.email}</p>
                                </div>
                            </div>

                            <div className="flex items-start gap-4 p-4 rounded-xl bg-gray-50 border border-gray-100">
                                <div className="w-10 h-10 rounded-lg bg-white shadow-sm flex-center text-indigo-500">
                                    <i className="fa-solid fa-phone text-lg"></i>
                                </div>
                                <div>
                                    <p className="text-xs font-bold text-gray-400 uppercase tracking-tight">Phone Number</p>
                                    <p className="text-sm font-semibold text-gray-700">{user?.country_code} {user?.phone_number}</p>
                                </div>
                            </div>

                            <div className="flex items-start gap-4 p-4 rounded-xl bg-gray-50 border border-gray-100">
                                <div className="w-10 h-10 rounded-lg bg-white shadow-sm flex-center text-green-500">
                                    <i className="fa-brands fa-whatsapp text-xl"></i>
                                </div>
                                <div className="flex-1">
                                    <p className="text-xs font-bold text-gray-400 uppercase tracking-tight">WhatsApp Link</p>
                                    <div className="flex items-center justify-between">
                                        <p className="text-sm font-semibold text-gray-700 truncate max-w-[15vmax]">
                                            {formatWhatsAppNumber(user?.country_code, user?.phone_number)}
                                        </p>
                                        <a href={formatWhatsAppNumber(user?.country_code, user?.phone_number)} target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:scale-110 transition-transform">
                                            <i className="fa-solid fa-up-right-from-square text-xs"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div className="flex items-start gap-4 p-4 rounded-xl bg-gray-50 border border-gray-100">
                                <div className="w-10 h-10 rounded-lg bg-white shadow-sm flex-center text-amber-500">
                                    <i className="fa-solid fa-location-dot text-lg"></i>
                                </div>
                                <div>
                                    <p className="text-xs font-bold text-gray-400 uppercase tracking-tight">Current Address</p>
                                    <p className="text-sm font-semibold text-gray-700 leading-snug">
                                        {user?.street_address ? `${user.street_address}, ${user.city}, ${user.country}` : "Not provided"}
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Financial Details Section */}
                        <div className="mt-4">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="h-[2px] flex-1 bg-gray-100"></div>
                                <h4 className="text-[1vmax] font-bold text-gray-400 uppercase tracking-[0.1em]">Financial Details</h4>
                                <div className="h-[2px] flex-1 bg-gray-100"></div>
                            </div>

                            <div className="bg-indigo-600 rounded-2xl p-[2vmax] text-white shadow-lg shadow-indigo-200 relative overflow-hidden group">
                                {/* Decorative Circles */}
                                <div className="absolute -top-10 -right-10 w-40 h-40 bg-white/10 rounded-full blur-3xl group-hover:scale-150 transition-transform duration-700"></div>
                                <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-indigo-400/20 rounded-full blur-3xl"></div>
                                
                                <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                    <div>
                                        <p className="text-indigo-100 text-xs font-bold uppercase mb-1">Bank Name</p>
                                        <p className="text-lg font-bold tracking-wide">{user?.bank_name || "N/A"}</p>
                                    </div>
                                    <div>
                                        <p className="text-indigo-100 text-xs font-bold uppercase mb-1">Account Holder</p>
                                        <p className="text-lg font-bold tracking-wide capitalize">{user?.account_title || "N/A"}</p>
                                    </div>
                                    <div className="lg:col-span-1">
                                        <p className="text-indigo-100 text-xs font-bold uppercase mb-1">Account Number / IBAN</p>
                                        <p className="text-lg font-bold tracking-wider font-mono">{user?.account_number || "•••• •••• ••••"}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {showSection && <UpdateAvatar hideSection={hideSection} avatar_url={user?.avatar_url} />}
            
            <div className="h-[10vmax]"></div>
        </Fragment>
    )
}

export default Profile